"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOISE = void 0;
const noise_1 = require("./noise");
__exportStar(require("./noise"), exports);
/**
 * Default configuration, it will generate new noise static key and enable noise pipes (IK handshake).
 */
exports.NOISE = new noise_1.Noise();
//# sourceMappingURL=index.js.map